import React from 'react';
import {Icon} from '@bosch/react-frok';
import {formatFiletype, getIconName} from '../../utils';
import {ThumbDescription, ThumbImage, ThumbnailPlaceholderContainer} from './ItemThumbPlaceholder.style';
import {LayoutViewType} from '../../models/LayoutViewType';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface ItemThumbPlaceholderProps {
    readonly contentType: string | null;
    readonly viewType: LayoutViewType;
}

/**
 * @name ItemThumbPlaceholder
 * @param { string } contentType        The item's contentType derived from its metadata
 * @param { string } viewType       The view via which the util was called, i.e. grid,list or table view
 * @description
 * Component to present a placeholder thumbnail in item tiles whenever there's no thumbnail provided
 */
export const ItemThumbPlaceholder: React.VFC<ItemThumbPlaceholderProps> = (props) => {
    const iconName = getIconName(props.contentType);

    if (props.viewType === LayoutViewType.TABLE) {
        return <Icon id={generateIdentifier()} iconName={iconName}/>;
    } else {
        return (
            <ThumbnailPlaceholderContainer id={generateIdentifier()}
                                           isFolder={props.contentType === 'folder'}
                                           className='-primary'>
                <ThumbImage id={generateIdentifier()} iconName={iconName}/>
                <ThumbDescription id={generateIdentifier()}
                                  className='highlight -size-m'>{formatFiletype(props.contentType).toUpperCase()}
                </ThumbDescription>
            </ThumbnailPlaceholderContainer>
        );
    }
};
